import React from 'react';

import { TemplateList } from '@weezevent/templar';
import { Card, ContentCard } from '@weezevent/nacre';

export const TemplatesList = () => {
    return (
        <Card>
            <ContentCard>
                <TemplateList detailsUrl={template => `emails/templates/templates/${template.id}`} />
            </ContentCard>
        </Card>
    );
};
